/**
 * ZENT CARE - FINAL ULTIMATE STABLE VERSION (V8)
 * - Desktop: Mosaic Swap (preserves order)
 * - Mobile: Original Scroll
 * - Fixes: Button grey-out, Payment Buttons re-init, Price updates
 * - Fix V8: updateButtonPrice przyjmuje wariant bezpośrednio (naprawa ceny przy wariantach)
 */
!function() {
    "use strict";

    class t extends window.theme.DeferredMedia {
        constructor() { super() }
        loadContent() {
            super.loadContent();
            Shopify.loadFeatures([{ name: "model-viewer-ui", version: "1.0", onLoad: this.setupModelViewerUI.bind(this) }])
        }
        setupModelViewerUI(t) { t || (this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector("model-viewer"))) }
    }

    window.ProductModel = {
        loadShopifyXR() { Shopify.loadFeatures([{ name: "shopify-xr", version: "1.0", onLoad: this.setupShopifyXR.bind(this) }]) },
        setupShopifyXR(t) {
            t || (window.ShopifyXR ? (document.querySelectorAll('[id^="ProductJSON-"]').forEach((t => {
                window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove()
            })), window.ShopifyXR.setupXRElements()) : document.addEventListener("shopify_xr_initialized", (() => this.setupShopifyXR())))
        }
    };

    window.addEventListener("DOMContentLoaded", (() => { window.ProductModel && window.ProductModel.loadShopifyXR() }));

    if (!customElements.get("product-info")) {
        customElements.define("product-info", class extends HTMLElement {
            constructor() {
                super();
                this.quantityInput = this.querySelector("[data-quantity-input]");
                this.productImages = this.querySelector("product-images");
                this.productMediaList = this.querySelector("[data-product-media-list]");
                this.variantImageScroll = this.getAttribute("data-variant-image-scroll") === "true";
                this.productForm = this.querySelector("product-form");
                this.preProcessHtmlCallbacks = [];
                this.postProcessHtmlCallbacks = [];
            }

            connectedCallback() {
                try {
                    const t = this.dataset.productHandle;
                    window.Shopify?.Products?.recordRecentlyViewed && (t ? window.Shopify.Products.recordRecentlyViewed({handle: t}) : window.Shopify.Products.recordRecentlyViewed());
                } catch (e) { console.warn("Shopify tracking error:", e); }

                this.postProcessHtmlCallbacks.push(() => {
                    window?.Shopify?.PaymentButton?.init();
                    window?.ProductModel?.loadShopifyXR();
                });

                this.onVariantChangeUnsubscriber = subscribe(theme.PUB_SUB_EVENTS.optionValueSelectionChange, this.handleOptionValueChange.bind(this));
                this.initQuantityHandlers();
            }

            disconnectedCallback() {
                if (this.onVariantChangeUnsubscriber) this.onVariantChangeUnsubscriber();
            }

            updateMedia(mediaId) {
                if (!mediaId) return;
                const targetMedia = this.querySelector(`[data-image-id="${mediaId}"]`);
                if (!targetMedia) return;

                const actualMediaId = targetMedia.getAttribute("data-media-id");
                const isDesktop = !window.theme.isMobile();

                targetMedia.dispatchEvent(new CustomEvent("theme:media:select", { bubbles: true, detail: { id: actualMediaId } }));

                requestAnimationFrame(() => {
                    if (isDesktop) {
                        const mediaList = this.productMediaList || this.querySelector('.product__media-list');
                        const firstMedia = mediaList?.querySelector('[data-media-id]:not(.hidden)');

                        if (targetMedia && firstMedia && targetMedia !== firstMedia) {
                            const placeholder = document.createElement('div');
                            targetMedia.parentNode.insertBefore(placeholder, targetMedia);
                            firstMedia.parentNode.insertBefore(targetMedia, firstMedia);
                            placeholder.parentNode.insertBefore(firstMedia, placeholder);
                            placeholder.parentNode.removeChild(placeholder);
                        }
                        
                        if (this.variantImageScroll) {
                            const top = targetMedia.getBoundingClientRect().top;
                            window.theme.scrollTo(top);
                        }
                    } else if (this.productMediaList) {
                        this.productMediaList.scrollTo({ left: targetMedia.offsetLeft, behavior: 'smooth' });
                    }
                });
            }

            handleUpdateProductInfo(t) {
                return e => {
                    const variant = this.getSelectedVariant(e);
                    this.updateURL(t, variant?.id);
                    this.updateVariantInputs(variant?.id);
                    
                    if (!variant) {
                        this.setUnavailable();
                        return;
                    }

                    this.updateMedia(variant.featured_media?.id);
                    
                    if (this.productForm) {
                        if (variant.available) {
                            this.productForm.toggleSubmitButton(false, window.theme.strings.addToCart);
                        } else {
                            this.productForm.toggleSubmitButton(true, window.theme.strings.soldOut);
                        }
                    }

                    window?.Shopify?.PaymentButton?.init();

                    const a = (id) => {
                        const source = e.getElementById(`${id}-${this.sectionId}`);
                        const dest = this.querySelector(`#${id}-${this.dataset.section}`);
                        if (source && dest) dest.innerHTML = source.innerHTML;
                    };
                    a("Price");
                    a("Inventory");
                    a("Sku");

                    // [V8 FIX] Przekazujemy wariant bezpośrednio zamiast szukać w document
                    this.updateButtonPrice(variant);
                    publish(theme.PUB_SUB_EVENTS.variantChange, { data: { sectionId: this.sectionId, html: e, variant: variant } });
                }
            }

            getSelectedVariant(t) {
                const e = t.querySelector("variant-selects [data-selected-variant]")?.innerHTML;
                return e ? JSON.parse(e) : null;
            }

            updateVariantInputs(t) {
                this.querySelectorAll('input[name="id"]').forEach((i => {
                    i.value = t ?? "";
                    i.dispatchEvent(new Event("change", { bubbles: !0 }));
                }));
            }

            updateURL(t, e) {
                if (this.dataset.updateUrl !== "false") window.history.replaceState({}, "", `${t}${e ? `?variant=${e}` : ""}`);
            }

            handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
                if (!this.contains(event.target)) return;
                const r = target.dataset.productUrl || this.dataset.url;
                this.renderProductInfo({
                    requestUrl: `${r}?section_id=${this.sectionId}&option_values=${selectedOptionValues.join(",")}`,
                    targetId: target.id,
                    callback: this.handleUpdateProductInfo(r)
                });
            }

            renderProductInfo({ requestUrl, targetId, callback }) {
                this.abortController?.abort();
                this.abortController = new AbortController();
                fetch(requestUrl, { signal: this.abortController.signal })
                    .then(t => t.text())
                    .then(t => {
                        const e = (new DOMParser()).parseFromString(t, "text/html");
                        callback(e);
                    });
            }

            setUnavailable() {
                this.productForm?.toggleSubmitButton(true, window.theme.strings.unavailable);
            }

            initQuantityHandlers() {
                if (this.quantityInput) {
                    this.quantityInput.addEventListener("change", () => this.updateButtonPrice());
                }
            }

            // [V8 FIX] Przyjmuje wariant jako parametr — przy zmianie wariantu używa go bezpośrednio,
            // przy zmianie ilości (brak parametru) szuka aktualnie wybranego wariantu w DOM.
            updateButtonPrice(variant = null) {
                const priceEl = this.querySelector("[data-product-price]");
                if (!priceEl) return;

                const activeVariant = variant || (() => {
                    const selected = document.querySelector("variant-selects [data-selected-variant]");
                    return selected ? JSON.parse(selected.innerHTML) : null;
                })();

                if (!activeVariant) return;

                const qty = parseInt(this.querySelector("[data-quantity-input]")?.value || "1", 10);
                priceEl.innerHTML = window.theme.formatMoney(activeVariant.price * qty, theme.moneyFormat);
            }

            get sectionId() { return this.dataset.originalSection || this.dataset.section; }
        });
    }

    customElements.get("product-model") || customElements.define("product-model", t);
}();